import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTrash = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M9.333.667a2 2 0 0 1 2 2v.666H14c.335 0 .612.247.66.568l.007.099a.667.667 0 0 1-.667.667h-.667v8.666a2 2 0 0 1-1.85 1.995l-.15.005H4.667a2 2 0 0 1-2-2V4.667H2a.668.668 0 0 1-.66-.568L1.334 4c0-.368.299-.667.667-.667h2.666v-.666c0-1.055.817-1.918 1.851-1.995l.15-.005zm2.666 4H4v8.666c0 .335.247.612.568.66l.099.007h6.666a.666.666 0 0 0 .667-.667V4.667zm-5.332 2c.368 0 .666.298.666.666v4a.666.666 0 1 1-1.333 0v-4c0-.368.298-.666.667-.666zm2.666 0c.369 0 .667.298.667.666v4a.666.666 0 1 1-1.333 0v-4c0-.368.298-.666.666-.666zm0-4.667H6.667A.666.666 0 0 0 6 2.667v.666h4v-.666a.668.668 0 0 0-.568-.66L9.333 2z"
	})
});
export default SvgTrash;
